// extracted by mini-css-extract-plugin
export default {"container":"xYirXDZpZ81HwUmaMdMl","scrollable-content":"wBsNZOWj6x3n5mIzduxi","footer":"qXml7oRuLrFSG9BaIwVw","colorBox":"pVZQLLPcB_CU8LYT30vy"};